import { render } from "./MyRegister_agree.vue?vue&type=template&id=97c58760"
import script from "./MyRegister_agree.vue?vue&type=script&lang=js"
export * from "./MyRegister_agree.vue?vue&type=script&lang=js"

import "./MyRegister_agree.vue?vue&type=style&index=0&id=97c58760&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__